import React from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";

function RacunovodstvoPredmetM() {
  return (
    <>
      <Navbar />
      <Bredcom title="Početna" subtitle="Računovodstvo" />
      <div className="container mt-4 pt-40">
        <div className="row">
          <div className="col-md-8">
            <div className="content-container">
              <h2 className="section-title">Računovodstvo</h2>
              <p>
                <strong>Studijski program:</strong> Menadžment
              </p>
              <p>
                <strong>Naziv predmeta:</strong> Računovodstvo
              </p>
              <p>
                <strong>Nastavnik:</strong>{" "}
              </p>
              <p>
                <strong>Status predmeta:</strong> Obavezan
              </p>
              <p>
                <strong>Broj ECTS:</strong> 8
              </p>
              <p>
                <strong>Uslov:</strong> Ekonomija
              </p>
              <h3>Cilj predmeta</h3>
              <p>
                Upoznavanje studenata sa osnovnim informacionim prednostima
                računovodstva kao bazičnog informacionog sistema za svako
                preduzeće. Kroz realizaciju nastavnog sadržaja studentima se
                pružaju neophodna teoretsko-praktična znanja što doprinosi
                njihovom osposobljavanju za rad u knjigovodstvu kao i analizi
                finansijskih izveštaja uz striktnu primjenu međunarodnih
                računovodstvenih standarda.
              </p>
              <h3>Ishod predmeta</h3>
              <p>
                Savladavanjem studijskog programa studenti su osposobljeni da
                praktično pružaju računovodstvene usluge i koriste cjelokupan
                informacioni potencijal računovodstva kako za interne tako i za
                eksterne potrebe.
              </p>
              <h3>Sadržaj predmeta</h3>
              <p>
                Teorijska nastava: Pojam koncept računovodstva i dvojno
                knjigovodstvo; Knjigovodstvena dokumentacija; Kontni okvir;
                Instrumenti knjigovodstva; Osnovne bilansne promjene;
                Knjigovodstveni računi; Poslovne knjige; Pribavljanje
                finansijskih sredstava; Pribavljanje materijala i robe;
                Pribavljanje osnovnih sredstava; Pojam rashoda i troškova;
                Prirodne vrste troškova; Nabavna vrijednost prodate robe u
                trgovini na veliko i malo; Vanredni rashodi finansijski i ostali
                rashodi; Pojam vrste i vrednovanje prihoda; Metode utvrđivanja
                finansijskog rezultata. Praktična nastava po tematskim cjelinama
                prati predavanja što podrazumijeva interaktivno učešće studenata
                u vidu diskusija kreativnih radionica i rješavanja konkretnih
                problema.
              </p>

              <h3>Metode izvođenja nastave</h3>
              <p>
                Predavanja se izvode putem prezentacija uz dodatna objašnjenja
                profesora. Vježbe se odnose na rješavanje problema iz prakse i
                simulacije u laboratorijama.
              </p>

              <h3 className="pt-20 pb-10">Plan rada</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Nedjelja</th>
                    <th>Fond časova</th>
                    <th>Sadržaj</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Pripremna</td>
                    <td>Upoznavanje, dogovor o radu i slično</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>I</td>
                    <td>3P + 2V</td>
                    <td>Pojam koncept računovodstva i dvojno knjigovodstvo</td>
                  </tr>
                  <tr>
                    <td>II</td>
                    <td>3P + 2V</td>
                    <td>Knjigovodstvena dokumentacija</td>
                  </tr>
                  <tr>
                    <td>III</td>
                    <td>3P + 2V</td>
                    <td>Kontni okvir; Instrumenti knjigovodstva</td>
                  </tr>
                  <tr>
                    <td>IV</td>
                    <td>3P + 2V</td>
                    <td>Osnovne bilansne promjene</td>
                  </tr>
                  <tr>
                    <td>V</td>
                    <td>3P + 2V</td>
                    <td>Knjigovodstveni računi; Poslovne knjige</td>
                  </tr>
                  <tr>
                    <td>VI</td>
                    <td></td>
                    <td>Kolokvijum I</td>
                  </tr>
                  <tr>
                    <td>VII</td>
                    <td>3P + 2V</td>
                    <td>Pribavljanje finansijskih sredstava</td>
                  </tr>
                  <tr>
                    <td>VIII</td>
                    <td>3P + 2V</td>
                    <td>Pribavljanje materijala i robe</td>
                  </tr>
                  <tr>
                    <td>IX</td>
                    <td>3P + 2V</td>
                    <td>Pribavljanje osnovnih sredstava</td>
                  </tr>
                  <tr>
                    <td>X</td>
                    <td>3P + 2V</td>
                    <td>Pojam rashoda i troškova</td>
                  </tr>
                  <tr>
                    <td>XI</td>
                    <td>3P + 2V</td>
                    <td>Prirodne vrste troškova</td>
                  </tr>
                  <tr>
                    <td>XII</td>
                    <td></td>
                    <td>Kolokvijum II</td>
                  </tr>
                  <tr>
                    <td>XIII</td>
                    <td>3P + 2V</td>
                    <td>
                      Nabavna vrijednost prodate robe u trgovini na veliko i
                      malo
                    </td>
                  </tr>
                  <tr>
                    <td>XIV</td>
                    <td>3P + 2V</td>
                    <td>
                      Vanredni rashodi finansijski i ostali rashodi; Pojam vrste
                      i vrednovanje prihoda
                    </td>
                  </tr>
                  <tr>
                    <td>XV</td>
                    <td>3P + 2V</td>
                    <td>Metode utvrđivanja finansijskog rezultata</td>
                  </tr>
                  <tr>
                    <td>XVI</td>
                    <td></td>
                    <td>Sveobuhvatni ispit</td>
                  </tr>
                  <tr>
                    <td>XVII</td>
                    <td></td>
                    <td>Ovjera semestra i upis ocjena</td>
                  </tr>
                  <tr>
                    <td>XVIII</td>
                    <td></td>
                    <td>Popravni ispitni rok</td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Obaveze studenata</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Obaveze studenata</th>
                    <th>U toku nastave</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Obaveze studenata u toku nastave</td>
                    <td>
                      Studenti su obavezni da pohađaju nastavu, vježbe i ispite
                    </td>
                  </tr>
                  <tr>
                    <td>Konsultacije</td>
                    <td>
                      Konsultacije se održavaju sa nastavnikom i saradnikom
                      poslije časova
                    </td>
                  </tr>
                  <tr>
                    <td>Opterećenje studenata u časovima</td>
                    <td>
                      <table className="table table-bordered ofpep-section">
                        <thead>
                          <tr>
                            <th>Nedjeljno</th>
                            <th>U semestru</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Ukupno: 5 č / 345 h</td>
                            <td>Ukupno: 90 č</td>
                          </tr>
                          <tr>
                            <td>Predavanja: 3 č / 215 h</td>
                            <td>Nastava + završni ispit: 65 č</td>
                          </tr>
                          <tr>
                            <td>Vježbe: 2 č / 130 h</td>
                            <td>Priprema i ovjera semestra: 10 č</td>
                          </tr>
                          <tr>
                            <td>Individualni rad:</td>
                            <td>Priprema i polaganje popravnog ispita: 15 č</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
              <h3 className="pt-20 pb-10">Ocjenjivanje</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Ocjena</th>
                    <th>Broj poena</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>A(odličan)</td>
                    <td>91-100</td>
                  </tr>
                  <tr>
                    <td>B(vrlo dobar)</td>
                    <td>81-90</td>
                  </tr>
                  <tr>
                    <td>C(dobar)</td>
                    <td>71-80</td>
                  </tr>
                  <tr>
                    <td>D(zadovoljava)</td>
                    <td>61-70</td>
                  </tr>
                  <tr>
                    <td>E(dovoljan)</td>
                    <td>51-60</td>
                  </tr>
                  <tr>
                    <td>F(nedovoljan)</td>
                    <td>0-50</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-md-4 pt-10">
            <aside className="sidebar-widget">
              <section
                id="custom_html-5"
                className="widget_text widget widget_custom_html"
              >
                <h2 className="widget-title">Zapratite nas</h2>
                <div className="textwidget custom-html-widget">
                  <div className="widget-social">
                    <a
                      href="https://www.facebook.com/fpebar.me"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      href="https://www.instagram.com/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      href="https://www.youtube.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube" />
                    </a>
                    <a
                      href="https://www.tiktok.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Tiktok"
                      title="Tiktok"
                    >
                      <i className="fab fa-tiktok" />
                    </a>
                    <a
                      href="https://www.linkedin.com/school/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on LinkedIn"
                      title="LinkedIn"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </section>
              <section id="categories-1" className="widget widget_categories">
                <h2 className="widget-title">Korisni linkovi</h2>
                <ul>
                  <li className="cat-item cat-item-16">
                    <Link to="/o-fpep">O Fakultetu</Link>
                  </li>
                  <li className="cat-item cat-item-23">
                    <Link to="/akreditacija-fpep">Akreditacija FPEP-a</Link>
                  </li>
                  <li className="cat-item cat-item-18">
                    <Link to="/upis">Upis</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/cijene-studija">Školarina</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/erasmus">Erasmus+</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/projekti">Projekti</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/dom-studenata">Dom studenata</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/galerija">Galerija</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/novosti">Novosti</Link>
                  </li>
                </ul>
              </section>
              <section
                id="recent-posts-4"
                className="widget widget_recent_entries"
              >
                <h2 className="widget-title">Studijski programi</h2>
                <ul>
                  <li>
                    <span className="post-date">
                      <strong>Osnovne studije</strong> <br />
                    </span>
                    <Link to="/racunovodstvo-finansije-i-bankarstvo">
                      Računovodstvo, bankarstvo i finansije
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment">
                      Menadžment
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-osnovne">
                      Pravo
                      <br />
                    </Link>
                  </li>
                  <li>
                    <span className="post-date">
                      <strong>Master studije</strong> <br />
                    </span>
                    <Link to="/poslovna-ekonomija">
                      Poslovna ekonomija
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/ekonomija-javnog-sektora">
                      Ekonomija javnog sektora
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-master">
                      Pravo
                      <br />
                    </Link>
                  </li>
                </ul>
              </section>
            </aside>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default RacunovodstvoPredmetM;
